// Terms pass B — send panel: counts, typed recipient-count confirm, retry failed rows only. Platform admin only.
import { useState } from "react";
import { Card, btn, call, errText, ghost, inp } from "./shared";

export function SendPanel({ slug, c, admin, onDone }) {
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn) => {
    setMsg(null); setBusy(true);
    try { setMsg(await fn()); setConfirm(""); } catch (e) { setMsg(errText(e)); } finally { setBusy(false); onDone(); }
  };
  const k = c.counts;
  return (
    <Card title="Send notice" testId="notice-send-panel" right={<span className="text-xs text-[#6b7280]">About 1 email per second</span>}>
      <div className="text-sm flex gap-4 flex-wrap" data-testid="notice-counts">
        <span>Sent <b data-testid="notice-count-sent">{k.sent}</b></span><span>Failed <b data-testid="notice-count-failed">{k.failed}</b></span>
        <span>Queued <b>{k.queued + k.sending}</b></span><span>Mocked <b data-testid="notice-count-mocked">{k.mocked}</b></span>
        <span>Ready to send <b data-testid="notice-ready-count">{c.ready_to_send}</b></span>
      </div>
      {c.selected_without_email.length > 0 && (
        <div className="text-xs text-[#a16207]" data-testid="notice-no-email-list">Selected but no AP email (will be skipped): {c.selected_without_email.map((x) => x.company_name).join(", ")}</div>
      )}
      {!admin ? <div className="text-xs text-[#6b7280]">Only a platform admin can send.</div> : (
        <div className="flex gap-2 items-center flex-wrap">
          <input className={`${inp} w-48`} inputMode="numeric" placeholder={`Type ${c.ready_to_send} to confirm`} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="notice-confirm-count" />
          <button className={btn} disabled={busy || c.approval_label !== "APPROVED" || Number(confirm) !== c.ready_to_send || c.ready_to_send === 0}
            onClick={() => run(async () => { const r = await call("post", "/campaign/send", slug, { confirm_count: Number(confirm) }); return `Queued ${r.queued}.`; })} data-testid="notice-send">Send to {c.ready_to_send}</button>
          <button className={ghost} disabled={busy || k.failed === 0 || c.approval_label !== "APPROVED"}
            onClick={() => run(async () => { const r = await call("post", "/campaign/retry-failed", slug); return `Re-queued ${r.requeued} failed.`; })} data-testid="notice-retry-failed">Retry failed only</button>
          {c.approval_label !== "APPROVED" && <span className="text-xs text-[#b91c1c]">Wording is UNAPPROVED.</span>}
        </div>
      )}
      {msg && <div className="text-xs" data-testid="notice-send-msg">{msg}</div>}
    </Card>
  );
}
